export default __webpack_public_path__ + "static/media/3l.94d3885f.svg";